<div class="hmf-m-l hmf-mx-m-xxl hmf-my-m-xl resend-confirmation-modal-body">
    <hmf-alert-banner
        *ngIf="resendError"
        messageType="error"
        messageTitle="Resend Error"
        [messageBody]="'Please double check your email, or contact <a href=&#34;/s/help-desk&#34;>customer service</a> for additional support.'"
    />
    <div class="hmf-header-bold-m resend-confirmation-modal-header hmf-mt-m">{{ !resendSuccess ? 'Resend your Order Confirmation' : 'Resend Successful'}}</div>
    <div class="hmf-body-m hmf-mt-xxs hmf-mb-m">{{ !resendSuccess ? 'Verify or update the email below and we\'ll resend your confirmation email to your inbox.' : 'Check your inbox for the updated confirmation email. Please allow up to 30 minutes for the email to reach your inbox.' }}</div>

    <form [formGroup]="confirmationForm" *ngIf="!resendSuccess">
        <hmf-text-input
            [type]="'email'"
            [pattern]="emailPattern"
            [error]="!!confirmationForm.get('confirmationEmail')?.errors"
			[errorIconEnabled]="!!confirmationForm.get('confirmationEmail')?.errors"
            [label]="'Email Address'"
            formControlName="confirmationEmail"
        />
    </form>
        <hmf-button
        *ngIf="resendSuccess; else defaultButton"
        class="confirmation-email-submit"
        [variant]="'primary'"
        [text]="'Back To Order'"
        (click)="closeModal()">
    </hmf-button>
    <ng-template #defaultButton>
        <hmf-button
            (click)="sendConfirmation()"
            class="confirmation-email-submit hmf-mt-s"
            [variant]="'primary'"
            [text]="'Send confirmation'">
        </hmf-button>
    </ng-template>

</div>
